(() => {
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const readState = key => {
    try { return JSON.parse(localStorage.getItem(key) || '{}') || {}; }
    catch { return {}; }
  };
  const saveState = (key, state) => {
    try { localStorage.setItem(key, JSON.stringify(state)); }
    catch {}
  };
  const waitingForCookieChoice = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.shouldShowBanner || !privacy?.currentVisitorConsent) return false;
    try {
      const consent = privacy.currentVisitorConsent();
      return privacy.shouldShowBanner() && ['marketing','analytics','preferences'].every(signal => !consent[signal]);
    } catch { return false; }
  };
  const captchaChallengeVisible = () => Array.from(document.querySelectorAll('iframe[src*="hcaptcha.com"]')).some(frame => {
    const bounds = frame.getBoundingClientRect();
    const style = getComputedStyle(frame);
    return bounds.width > 100 && bounds.height > 100 && style.visibility !== 'hidden' && style.display !== 'none';
  });
  const initNewsletter = () => {
    const original = document.querySelector('[data-nk-newsletter]');
    if (!original || original.dataset.nkEnhanced) return;
    if (/^\/(?:checkouts?|cart)(?:\/|$)/.test(location.pathname)) return;
    const dialog = original;
    const overlay = document.createElement('div');
    overlay.className = 'nk-newsletter-overlay';
    overlay.hidden = true;
    dialog.before(overlay);
    overlay.appendChild(dialog);
    dialog.dataset.nkEnhanced = 'true';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    const closeButton = dialog.querySelector('[data-nk-newsletter-close]');
    closeButton.hidden = false;
    const key = dialog.dataset.nkStorageKey;
    const success = dialog.querySelector('[data-nk-newsletter-success]');
    const error = dialog.querySelector('[data-nk-newsletter-error]');
    const focusSelector = 'button:not([disabled]):not([hidden]),a[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    const focusable = () => Array.from(dialog.querySelectorAll(focusSelector)).filter(element => element.getClientRects().length);
    let previousFocus;
    let timer;
    const clearTimer = () => window.clearTimeout(timer);
    const updateModalState = () => {
      const value = captchaChallengeVisible() ? 'false' : 'true';
      if (dialog.getAttribute('aria-modal') !== value) dialog.setAttribute('aria-modal', value);
    };
    const captchaObserver = new MutationObserver(updateModalState);
    const open = () => {
      if (!dialog.isConnected || !overlay.hidden) return;
      clearTimer();
      previousFocus = document.activeElement;
      overlay.hidden = false;
      dialog.classList.add('nk-newsletter--open');
      updateModalState();
      captchaObserver.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class','hidden','aria-hidden']});
      (error || success || dialog.querySelector('h2')).focus({preventScroll:true});
    };
    const close = () => {
      if (overlay.hidden) return;
      const state = readState(key);
      if (!state.subscribed) saveState(key, {...state, dismissedAt:Date.now()});
      clearTimer();
      captchaObserver.disconnect();
      overlay.hidden = true;
      dialog.classList.remove('nk-newsletter--open');
      if (previousFocus?.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({preventScroll:true});
    };
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', event => {
      if (event.target === overlay) close();
    });
    document.addEventListener('focusin', event => {
      if (overlay.hidden || captchaChallengeVisible() || dialog.contains(event.target)) return;
      (focusable()[0] || dialog.querySelector('h2')).focus({preventScroll:true});
    });
    document.addEventListener('keydown', event => {
      if (overlay.hidden || captchaChallengeVisible()) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const elements = focusable();
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !elements.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    dialog.nkOpen = open;
    document.querySelectorAll('[data-nk-newsletter-trigger]').forEach(trigger => { trigger.hidden = false; });
    if (success) {
      saveState(key, {subscribed:true});
      if (success.dataset.nkNewsletterPosted === 'true') open();
      return;
    }
    if (error) { open(); return; }
    const state = readState(key);
    if (state.subscribed || (state.dismissedAt && Date.now() - state.dismissedAt < sevenDays)) return;
    const eligibleFrom = Date.now() + 20000;
    const tryOpen = () => {
      if (!dialog.isConnected) return;
      const current = readState(key);
      if (current.subscribed || (current.dismissedAt && Date.now() - current.dismissedAt < sevenDays)) return;
      const otherDialog = Array.from(document.querySelectorAll('dialog[open],[role="dialog"],[aria-modal="true"]')).some(element => element !== dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      if (Date.now() < eligibleFrom || document.visibilityState !== 'visible' || waitingForCookieChoice() || otherDialog || document.querySelector('.nk-mobile-menu[open]') || document.activeElement?.matches('input,textarea,select')) {
        timer = window.setTimeout(tryOpen, 5000);
        return;
      }
      open();
    };
    timer = window.setTimeout(tryOpen, 20000);
    document.addEventListener('visitorConsentCollected', () => {
      clearTimer();
      timer = window.setTimeout(tryOpen, Math.max(1000, eligibleFrom - Date.now()));
    });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-nk-newsletter-trigger]');
    if (!trigger) return;
    const dialog = document.querySelector('[data-nk-newsletter][data-nk-enhanced]');
    if (!dialog?.nkOpen) return;
    event.preventDefault();
    dialog.nkOpen();
  });
  initNewsletter();
  document.addEventListener('shopify:section:load', initNewsletter);
})();
